const UserDisplayName = {
  get: (name) => {
    if (name) {
      const parts = name.split('@')
      return parts[0].length > 25
        ? parts[0].substr(0, 25)
        : parts[0]
    } else {
      return ''
    }
  }
}

export {
  UserDisplayName
}
